"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModificationRequestFeeType = exports.ModificationRequestState = void 0;
const immutable_1 = require("immutable");
const luxon_1 = require("luxon");
const OfferPricingDetails_1 = require("../OfferPricingDetails");
const User_1 = require("../User");
const ModificationRequestDeliverable_1 = require("./ModificationRequestDeliverable");
const ModificationRequestItem_1 = require("./ModificationRequestItem");
class ModificationRequest {
    constructor({ id, bucketId, state, feedback, targetDeliverableId, items, sender, createdAt, submittedAt, deliverables, approvedAt, deliveryDue, feeType, offerPricingDetail, }) {
        this.toJSON = () => ({
            id: this.id,
            bucketId: this.bucketId,
            state: this.state,
            feedback: this.feedback,
            targetDeliverableId: this.targetDeliverableId,
            items: this.items,
            sender: this.sender.toJSON(),
            createdAt: this.createdAt.toISO(),
            submittedAt: this.submittedAt ? this.submittedAt.toISO() : null,
            deliverables: this.deliverables,
            approvedAt: this.approvedAt ? this.approvedAt.toISO() : null,
            deliveryDue: this.deliveryDue ? this.deliveryDue.toISO() : null,
            feeType: this.feeType,
            offerPricingDetail: this.offerPricingDetail,
        });
        this.id = id;
        this.bucketId = bucketId;
        this.state = state;
        this.feedback = feedback;
        this.targetDeliverableId = targetDeliverableId;
        this.items = items;
        this.sender = sender;
        this.createdAt = createdAt;
        this.submittedAt = submittedAt;
        this.deliverables = deliverables;
        this.approvedAt = approvedAt;
        this.deliveryDue = deliveryDue;
        this.feeType = feeType;
        this.offerPricingDetail = offerPricingDetail;
    }
    get latestModificationRequestDeliverable() {
        if (!this.deliverables) {
            return;
        }
        return this.deliverables.sort((a, b) => b.createdAt.valueOf() - a.createdAt.valueOf()).first();
    }
}
ModificationRequest.fromJSON = (json) => {
    const { id, bucketId, state, feedback, targetDeliverableId, items, sender, createdAt, submittedAt, deliverables, approvedAt, deliveryDue, feeType, offerPricingDetail, } = Object.assign({}, json);
    if (typeof id !== 'string')
        throw new Error('.id must be a string');
    if (bucketId && typeof bucketId !== 'string')
        throw new Error('.bucketId must be a string');
    if (state !== undefined && Object.keys(exports.ModificationRequestState).indexOf(state) === -1)
        throw new Error('.state must be any one of project state');
    if (typeof targetDeliverableId !== 'string')
        throw new Error('.targetDeliverableId must be a string');
    if (!Array.isArray(items))
        throw new Error('.items must be an array');
    if (typeof createdAt !== 'string')
        throw new Error('.createdAt must be a string');
    // FIXME: submittedAtがDATETIME型で渡されると、例外が投げられるのではないか
    if (submittedAt !== undefined && submittedAt !== null && typeof submittedAt !== 'string')
        throw new Error('.submittedAt must be a string');
    if (!Array.isArray(deliverables))
        throw new Error('.deliverables must be an array');
    if (approvedAt !== undefined && approvedAt !== null && typeof approvedAt !== 'string')
        throw new Error('.approvedAt must be a string');
    if (deliveryDue !== undefined && deliveryDue !== null && typeof deliveryDue !== 'string')
        throw new Error('.deliveryDue must be a string');
    if (feeType !== undefined && Object.keys(exports.ModificationRequestFeeType).indexOf(feeType) === -1)
        throw new Error('.feeType must be any one of fee type');
    const _items = immutable_1.List(items).map(item => ModificationRequestItem_1.default.fromJSON(item));
    const _deliverables = immutable_1.List(deliverables).map(item => ModificationRequestDeliverable_1.default.fromJSON(item));
    const _offerPricingDetail = offerPricingDetail ? OfferPricingDetails_1.default.fromJSON(offerPricingDetail) : undefined;
    return new ModificationRequest({
        id,
        bucketId,
        state,
        feedback,
        targetDeliverableId,
        items: _items,
        sender: User_1.DirectorUser.fromJSON(sender),
        createdAt: luxon_1.DateTime.fromISO(createdAt),
        submittedAt: submittedAt ? luxon_1.DateTime.fromISO(submittedAt) : null,
        deliverables: _deliverables,
        approvedAt: approvedAt ? luxon_1.DateTime.fromISO(approvedAt) : null,
        deliveryDue: deliveryDue ? luxon_1.DateTime.fromISO(deliveryDue) : null,
        feeType,
        offerPricingDetail: _offerPricingDetail,
    });
};
exports.ModificationRequestState = {
    draft: 'draft',
    submitted: 'submitted',
    responded: 'responded',
    approved: 'approved',
    given_feedback: 'given_feedback',
};
exports.ModificationRequestFeeType = {
    fee: 'fee',
    no_fee: 'no_fee',
};
exports.default = ModificationRequest;
